<template>
  <card>
    <template slot="header">
      <h4 class="card-title">{{ title }}</h4>
      <p class="card-category"></p>
    </template>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table">
            <tbody>
            <tr>
              <td><strong>Name</strong></td>
              <td class="text-right"><strong>Total</strong></td>
            </tr>
            <tr v-for="(item, index) in items" :key="index">
              <td>{{$t(item.title)}}</td>
              <td class="text-right">{{item.value}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
  import Loading from 'src/components/LoadingPanel.vue';

  const WorldMap = () => ({
    loading: Loading,
    delay: 200
  });
  export default {
    name: 'list-card',
    components: {
    },
    props: {
      items: Array,
      title: String,
    }
  };
</script>
<style></style>
